import { render, staticRenderFns } from "./app-footer-minimal.vue?vue&type=template&id=70430111&scoped=true&"
import script from "./app-footer-minimal.vue?vue&type=script&lang=js&"
export * from "./app-footer-minimal.vue?vue&type=script&lang=js&"
import style0 from "./app-footer-minimal.vue?vue&type=style&index=0&id=70430111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70430111",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70430111')) {
      api.createRecord('70430111', component.options)
    } else {
      api.reload('70430111', component.options)
    }
    module.hot.accept("./app-footer-minimal.vue?vue&type=template&id=70430111&scoped=true&", function () {
      api.rerender('70430111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/app-footer-minimal.vue"
export default component.exports